import * as React from "react";
import Select from "react-select";
import * as moment from "moment";
import { CalendarState } from "burde";
import { OptionType } from "appz";
import { getValidMonths } from "page/calendar/step/3-insert/service";
import { DefaultCulture } from "ui/constants";
import { actionCreators } from "page/calendar/store";
import { actionCreators as burdeContentActionCreators } from "burde-api-content/store";

type CalendarDatePickerProps = {
    DatePicker_SelectMonth: string;
    calendar: CalendarState;
    isAuthenticated: boolean;
} & typeof actionCreators &
    typeof burdeContentActionCreators;

interface CalendarDatePickerState {
    validMonths: Array<string>;
    startDate: string;
}

const getValueFromOption = (option: OptionType) => {
    return option
        ? !Array.isArray(option)
            ? option.value || null
            : null
        : null;
};

const makeLabel = (selectedMonth: string) => {
    const momentMonth = moment(selectedMonth, "YYYY-MM-DD");
    const formattedYear = momentMonth.clone().format("YYYY");
    const formattedMonth = momentMonth.clone().format("MMMM");

    return (
        formattedYear +
        " - " +
        formattedMonth.charAt(0).toUpperCase() +
        formattedMonth.slice(1)
    );
};

class CalendarDatePicker extends React.Component<
    CalendarDatePickerProps,
    CalendarDatePickerState
> {
    public state: CalendarDatePickerState = {
        validMonths: [],
        startDate: this.props.calendar.startDate,
    };

    _isMounted: boolean = false;

    private changeMonth = (option: OptionType) => {
        const selectedMonth = getValueFromOption(option);

        if (!selectedMonth) {
            return;
        }

        const culture =
            this.props.calendar.culture !== null
                ? this.props.calendar.culture
                : DefaultCulture;

        const startDate = moment(selectedMonth, "YYYY-MM-DD").format(
            "YYYY-MM-DD",
        );

        this.props.updateStartDate(startDate);
        this.state.startDate = startDate;
    };

    componentDidMount() {
        this._isMounted = true;
        getValidMonths().then((validMonths) => {
            if (this._isMounted === true) {
                this.setState({
                    validMonths,
                });
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const {
            DatePicker_SelectMonth,
            calendar: { dayModules, ...calendar },
        } = this.props;

        const { validMonths, startDate } = this.state;

        if (validMonths.length > 0) {
            if (!validMonths.includes(startDate)) {
                this.state.startDate = validMonths[0];
            }
        }

        const options = validMonths.map((month) => ({
            label: makeLabel(month),
            value: month,
        }));

        const selectedOption = options.find((x) => x.value === startDate);

        return (
            <Select
                isSearchable={false}
                onChange={this.changeMonth}
                options={options}
                placeholder={DatePicker_SelectMonth}
                value={selectedOption}
            />
        );
    }
}

export default CalendarDatePicker;
